import React from "react";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";

const TransactionCard = ({ data }) => {
  return (
    <div  className="max-w mx-auto bg-white shadow-xl rounded-xl p-6 border border-gray-100 hover:shadow-2xl transition-shadow duration-300">
      <h2 className="text-2xl font-semibold mb-5 text-gray-900 border-b border-gray-200 pb-2">
        Transaction Details
      </h2>

      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <span className="font-medium text-gray-600">Customer</span>
          <span className="text-gray-900 font-semibold truncate">
            {data.Customer_Full_Name}
          </span>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <span className="font-medium text-gray-600">Email</span>
          <span className="text-gray-900 font-semibold truncate">
            {data.Customer_Email_Address}
          </span>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <span className="font-bold text-gray-600">Amount</span>
          <h2
            className={`font-semibold ${
              data.Amount > 0 ? "text-green-600" : "text-red-600"
            }`}
          >
            ₦{formatCustomNumber(data.Amount|| 0)}
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <span className="font-medium text-gray-600">Convenience Fee</span>
          <span className="text-gray-900 font-semibold">
            ₦{formatCustomNumber(data.Convience_Fees_Amount || 0)}
          </span>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <span className="font-medium text-gray-600">Transaction Type</span>
          <span className="text-gray-900 font-semibold">
            {data.Transaction_Type_Name}
          </span>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <span className="font-medium text-gray-600">Transaction Group</span>
          <span className="text-gray-900 font-semibold">
            {data.Transaction_Group}
          </span>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <span className="font-medium text-gray-600">Reference No</span>
          <span className="text-gray-900 font-semibold truncate">
            {data.Ref_No}
          </span>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <span className="font-medium text-gray-600">Payment Ref</span>
          <span className="text-gray-900 font-semibold truncate max-w-[180px]">
            {data.Payment_Ref_No}
          </span>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <span className="font-medium text-gray-600">Transaction Date</span>
          <span className="text-gray-900 font-semibold">
            {new Date(data.Transaction_Date).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        </div>
      </div>

      {/* Optional Footer for Actions */}
    
    </div>
  );
};

export default TransactionCard; 